<template>
  <div class="pc-nav" :style="{ height: nonChrome ? '96px' : '56px' }">
    <div v-if="nonChrome" class="nonChrome">
      为了保证制作简历的安全性和流畅性，建议您使用Chrome浏览器进行访问
      <i class="iconfont iconx close" @click="close"></i>
    </div>
    <renameModal
      v-if="renameModalShow"
      :cvToken="renameCvToken"
      :cvName="renameCvName"
      @editCvName="editCvName"
    />
    <sendCvModal
      v-if="sendCvModalShow"
      :cvToken="cvDetail.basic_info.token"
      :cvName="renameCvName || cvDetail.basic_info.cv_name"
      @sendCv="sendCv"
      :profile="profile"
    />
    <div id="print-cover">正在打印中...如需编辑简历，请先关闭打印窗口</div>
    <div class="nav-container">
      <div class="cv">
        <div class="cv-me" @click="toCvs">
          <i class="iconfont iconchevron-left"></i>
          <span>我的简历</span>
        </div>
        <div
          class="cv-icon cv-name text-overflow"
          @click="
            editCvName(cvDetail.basic_info.token, cvDetail.basic_info.cv_name)
          "
        >
          <div class="cv-name-n text-overflow">
            {{ cvDetail.basic_info.cv_name || "未命名超级简历" }}
          </div>
          <i class="iconfont iconbianji"></i>
        </div>
      </div>
      <slot name="middle-nav"></slot>
      <div class="right-part">
        <div>
          <div
            class="ponter cv-btn tran margin-right-12"
            @click="translate"
            v-if="!cvDetail.basic_info.trans_cv_id"
          >
            <!--            <i class="iconfont iconfanyi" style="margin-right: 4px;"></i>-->
            翻译
            <!-- <div class="hover">翻译简历</div> -->
            <!-- <i class="el-icon-loading"></i> -->
          </div>

          <div v-if="!isMentor" class="cv-btn margin-right-12 share">
            <div class="more-icon" @click="downloadClick">下载</div>
          </div>

          <!-- <div class="cv-btn margin-right-12 share" >
            <div class='more-icon' @mouseover.stop="cvShareTooltip = false">
              发送
            </div>
            <div class="cv-share-old" style="display: none">
              <div style="margin: 32px 28px">
                <div class="send-to-wechat flex-c">
                  <div class="left">
                    <p class="nav">发送至微信</p>
                    <p class="auth-switch">
                      <el-switch v-model="settingData.public_visibility" @change="state=>{ updatePublicVisibility({public_visibility: state}, 'public_visibility') }" active-color="#FF6644" inactive-color="#CFCFCF" />
                      <span class="auth-switch-tips cursor_p" @click="updatePublicVisibility({public_visibility: !settingData.public_visibility}, 'public_visibility')">
                          已{{settingData.public_visibility ? '开启' : '关闭'}}简历追踪
                        </span>
                    </p>
                    <div class="copy-link flex-c pr">
                      <div class="auth-select-text">
                        对获得链接的人<span class="font_w_b" v-if="visibilityOptions[settingData.visibility_type]">{{visibilityOptions[settingData.visibility_type].title}}</span> <span class="iconfont iconxiala2"></span>

                        <div class="auth-select pa bg_fff">
                          <div class="select-item"
                               :class="[settingData.visibility_type==key?'select-item-active':'']"
                               v-for="key in visibilityOptionsList" :key="key"
                               @click="updatePublicVisibility({visibility_type: key}, 'visibility_type')"
                          >
                            对获得链接的人<span class="font_w_b">{{visibilityOptions[key].title}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="copy-link-btn" :value="shareUrl" @click="copy">复制并打开</div>
                    </div>
                  </div>
                  <qrcode-vue
                    :value="shareUrl"
                    :size="102"
                    class="share-cv-qrcode"
                    v-if="shareUrl"
                    :maskPattern="7"
                    logo="https://files.wondercv.com/qrcode-icon.png"
                  />
                  <div class="share-cv-qrcode" v-else>
                  </div>
                </div>
                <div class="send-to-email" @click="sendCv(cvDetail.basic_info.token)">
                  <div class="left">
                    <p class="nav">发送至邮箱</p>
                    <p class="title">输入邮箱地址，简历将以PDF格式发送至您的邮箱</p>
                  </div>
                  <div class="right" style="position: absolute; left: 410px; top: 200px">
                    <img style="width: 20px; height: 25px" src="@/assets/image/around-right.svg" alt="">
                  </div>
                </div>
              </div>
            </div>
            <div class="cv-share cv-share-new" :style="cvShareTooltip ? {display: 'none'} : {}">
              <div class="cv-share-item" @click="changeShareWxState" data-growing-container data-growing-idx="0">
                <i class="iconfont iconqiepian"></i>
                <span>微信</span>
              </div>
              <div class="cv-share-item" @click="sendCv(cvDetail.basic_info.token)" data-growing-container data-growing-idx="1">
                <i class="iconfont iconqiepianbeifen"></i>
                <span>邮箱</span>
              </div>
            </div>
            <div class="cv-share-tooltip" v-if="cvShareTooltip">
              <span>发送简历链接，请好友帮忙改简历吧~</span>
              <i class="iconfont iconx" @click="cvShareTooltip = false"></i>
            </div>
          </div> -->

          <div
            class="cv-btn"
            style="width: 67px !important; margin-right: 10px"
          >
            <div class="more-icon">
              <i
                class="iconfont iconmore-horizontal fontb"
                style="color: #fff; font-size: 24px; font-weight: 600"
              ></i>
            </div>
            <div class="cv-option">
              <!-- <div class="cv-list after" @click="translate"><i class="iconfont icontrash-"></i>翻译</div> -->
              <!-- <div class="cv-list after"><i class="iconfont icontrash-"></i>合并中英文</div> -->
              <!-- <div class="cv-list after" @click="privacy"><i class="iconfont iconsimidushezhi1"></i>简历私密度设置</div> -->
              <!--              <div class="cv-list" @click="download({type:'pdf'})"><i class="iconfont iconxiazai"></i>下载文件</div>-->
              <!-- <div v-if="!isMentor" class="cv-list" @click="downloadClick"><i class="iconfont iconxiazai"></i>下载文件</div> -->
              <!-- <img src="https://files.wondercv.com/pc-cvs/vip-icon.png" class="icoImg"/> -->
              <div class="cv-list" @click="changeShareWxState">
                <i class="iconfont iconqiepian"></i>发送到微信<img
                  src="https://files.wondercv.com/pc-cvs/vip-icon.png"
                  class="icoImg"
                />
              </div>
              <div class="cv-list" @click="sendCv(cvDetail.basic_info.token)">
                <i class="iconfont iconqiepianbeifen"></i>发送到邮箱
              </div>

              <div
                style="
                  border-top: 1px solid #e4e4e4;
                  width: 128px;
                  margin: auto;
                "
              ></div>
              <!--              <div class="cv-list" @click="download({type:'img'})"><i class="iconfont iconxiazaitupian"></i>下载图片</div>-->
              <div class="cv-list" @click="combineCv()">
                <i class="iconfont iconhebingzhongyingwen"></i>合并中英文
              </div>
              <!-- <div class="cv-list " @click="printCv"><i class="iconfont icondayin"></i>打印简历</div> -->
              <div v-if="!isMentor" class="cv-list" @click="dumpCv">
                <i class="iconfont iconfuzhi1"></i>复制简历
              </div>
              <div
                style="
                  border-top: 1px solid #e4e4e4;
                  width: 128px;
                  margin: auto;
                "
              ></div>
              <div v-if="!isMentor" class="cv-list" @click="deleteCv">
                <i class="iconfont iconshanchu1"></i>删除
              </div>
              <div
                v-if="!isMentor"
                style="
                  border-top: 1px solid #e4e4e4;
                  width: 128px;
                  margin: auto;
                "
              ></div>
              <div v-if="!isMentor" class="cv-list" @click="changeEditorTheme">
                <template v-if="personInfo.theme === 'dark'">
                  <i class="iconfont iconrijianmoshi"></i>日间模式
                </template>
                <template v-if="personInfo.theme === 'light'">
                  <i class="iconfont iconyejianmoshi"></i>暗夜模式
                </template>
              </div>
            </div>
          </div>
          <!--          <div class="change-theme" @click="changeEditorTheme">-->
          <!--            <transition name="icon">-->
          <!--              <img v-show="personInfo.theme === 'light'" src="https://files.wondercv.com/icon/sun.png" alt="">-->
          <!--            </transition>-->
          <!--            <transition name="icon">-->
          <!--              <img v-show="personInfo.theme === 'dark'" class="dark-theme" src="https://files.wondercv.com/icon/moon.png"-->
          <!--                   alt="">-->
          <!--            </transition>-->
          <!--          </div>-->
          <memberStatusPopup></memberStatusPopup>
          <app-icon
            code-image="https://files.wondercv.com/download-code/cv-editor-nav.png"
          />
          <div class="line"></div>
          <div>
            <personIcon @clickItem="updateLibrary" />
          </div>
        </div>
      </div>
    </div>
    <!-- 发送至微信弹窗 -->
    <div class="share-wechat-dialog-container" v-show="shareWxState">
      <div class="share-wechat-cover" @click="changeShareWxState"></div>
      <div class="share-wechat-content send-to-wechat">
        <span class="share-wechat-title">发送至微信</span>
        <div class="copy-link flex-c pr">
          <div
            class="auth-select-text"
            :class="{ 'auth-select-disabled': !settingData.public_visibility }"
          >
            <template v-if="settingData.public_visibility">
              对获得链接的人<span
                class="font_w_b"
                v-if="visibilityOptions[settingData.visibility_type]"
                >{{
                  visibilityOptions[settingData.visibility_type].title
                }}</span
              >
              <span class="iconfont iconxiala2"></span>
            </template>
            <template v-else>
              <span>已关闭简历分享链接</span>
            </template>
            <div
              class="auth-select pa bg_fff"
              :style="!settingData.public_visibility ? { display: 'none' } : {}"
            >
              <div
                class="select-item"
                :class="[
                  settingData.visibility_type === key
                    ? 'select-item-active'
                    : '',
                ]"
                v-for="key in visibilityOptionsList"
                :key="key"
                @click="
                  updatePublicVisibility(
                    { visibility_type: key },
                    'visibility_type'
                  )
                "
              >
                对获得链接的人<span class="font_w_b">{{
                  visibilityOptions[key].title
                }}</span>
              </div>
            </div>
          </div>
          <div class="copy-link-btn" :value="shareUrl" @click="copy">
            复制链接
          </div>
        </div>
        <img :src="shareimg" class="share-cv-qrcode" v-if="shareimg" />
        <div class="share-cv-qrcode" v-else></div>
        <!--        <qrcode-vue-->
        <!--          :value="shareimg"-->
        <!--          :size="102"-->
        <!--          class="share-cv-qrcode"-->
        <!--          v-if="shareimg"-->
        <!--          :maskPattern="7"-->
        <!--          logo="https://files.wondercv.com/qrcode-icon.png"-->
        <!--        />-->
        <span class="cv-share-desc">复制链接或微信扫码查看</span>
      </div>
    </div>
    <!-- 单词写错了,不要介意 -->
    <intention :show="intentionShow" @clone="intentionShow = false" />
    <!-- 下载弹窗 -->
    <!--    <download-before :type="downloadtype"-->
    <!--                     v-show="downloadShow"-->
    <!--                     :dialogState="downloadShow"-->
    <!--                     @handleClose="handleClose"-->
    <!--                     @trigger="trigger"-->
    <!--                     :token="cvDetail.basic_info.token"-->
    <!--    />-->
    <Dialog
      :dialogState="dialogShow"
      :download-state="downloadState"
      @handleClose="handleClose"
      :token="cvDetail.basic_info.token"
      v-if="dialogShow"
    />
    <CombineDialog
      :dialogState="combineDialogShow"
      @handleClose="handleCombineClose"
      v-if="combineDialogShow"
      @handleDownload="download"
      :token="cvDetail.basic_info.token"
      :cv_name="cvDetail.basic_info.cv_name"
      :cv_lang="cvDetail.basic_info.lang"
    />
    <!-- 纠错模式下，功能不可用 -->
    <div
      class="open-resume-error-cover-up"
      v-show="openResumeError"
      @click.stop="showCloseResumeError()"
      style="z-index: 9"
    ></div>
    <alert :alertData="alertData" @close="handleClose"></alert>
    <pay-alert
      v-if="payAlertState"
      displayContinueBtn
      @close="payAlertState = false"
      @downloadContinue="trigger(triggerPayload)"
    />
  </div>
</template>
<script>
import {
  cvOperationMixin,
  cvResumeErrorMixin,
} from "../../../../assets/js/mixins";
import appIcon from "@/components/base/phone";
let run = false;
import { mapState, mapGetters, mapMutations } from "vuex";
import Cookies from "js-cookie";
import api from "@/api";
import moment from "moment";

import personIcon from "@/components/base/personIcon";
import intention from "@/components/jobs/intention";

import {
  getSignature,
  getUserInfo,
  dealSignatrue,
  routerTo,
  displayBannerSaveHistory,
  updateAccountResumeText,
  getBannerParams
} from "~/assets/js/util";
import renameModal from "@/components/renameModal";
import sendCvModal from "@/components/editor/sendEmail";
import downloadjs from "downloadjs";
import axios from "axios";
import conditions from "@/assets/json/conditions";
import Dialog from "./download";
import CombineDialog from "./combine";
import { get_tUser } from "../../../../assets/js/util";
import DownloadBefore from "./downloadBefore";
import qrcodeVue from "qrcode-vue";
import memberStatusPopup from "@/components/base/memberStatusPopup.vue";
import alert from '../../../cvs/components/alert'
import payAlert from '../../../account/user/payAlert.vue'
import { FOREVER_PRICE } from '../../../../assets/js/const'
let printJS;
if (process.client) {
  printJS = require("print-js");
  // printJS = require('vue-print-nb');
}
import html2canvas from "html2canvas";

export default {
  components: {
    DownloadBefore,
    intention,
    renameModal,
    sendCvModal,
    personIcon,
    Dialog,
    CombineDialog,
    appIcon,
    qrcodeVue,
    memberStatusPopup,
    alert,
    payAlert
  },
  props: {
    currHeader: {
      type: Number,
      default: null,
    },
    pageNum: {
      type: Number,
      default: 1,
    },
  },
  mixins: [cvOperationMixin, cvResumeErrorMixin],
  data() {
    return {
      downloadtype: 0,
      downloadShow: false,
      dialogShow: false, // 下载弹窗
      combineDialogShow: false, // 合并简历弹窗
      isTranslate: false, // 是否是翻译中
      isDump: false, // 是否处于复制中的简历
      printObj: {
        id: "download-resume",
      },
      intentionShow: false,
      navList: [
        { label: "简历模板", url: "/jianlimoban/" },
        { label: "简历修改", url: "/service/" },
        { label: "求职信", url: "/emails/my" },
        { label: "热门职位", url: "/jobs/" },
        { label: "简历攻略", url: "/blog/" },
        {
          label: "加入我们",
          url: "/welcome/join_us",
          img: "https://files.wondercv.com/hot-icon.png",
        },
      ],
      renameModalShow: false,
      sendCvModalShow: false,
      renameCvToken: "", //重命名简历token
      renameCvName: "", //重命名简历名称
      isDownloadCv: false,
      downloadState: false, // 简历下载状态

      shareUrl: "", // 分享微信url地址
      shareimg: null, // 分享小程序二维码
      cvEncodedToken: "", //加密之后的简历token
      settingData: {
        //当前简历权限
        public_visibility: true, //是否公开
        can_comment: true, // 是否可评论
        visibility_type: 20, //公开类型 10: 部分可见 20：全部可见
      },
      visibilityOptionsList: [20, 10], //用户设置-options-排序
      visibilityOptions: {
        //用户设置-options
        20: {
          title: "完整可见",
          desc: "可以查看你的完整简历",
        },
        10: {
          title: "保护隐私",
          desc: "可查看简历，但会隐藏你的姓名及联系方式",
        },
      },
      shareWxState: false,
      cvShareTooltip: false,
      timer: null,
      getMiniprogramImgState: false, //是否已经获取了分享需要的一些数据
      banner: "", //下载跳转banner
      alertData: {
        show: false,
        type: ''
      },
      payAlertState: false,
      triggerPayload: {}
    };
  },
  computed: {
    ...mapState("cvsEditor", ["cvToken"]),
    ...mapState("me", ["isLogin", "personInfo", "isMembership", "isUser"]),
    ...mapState("app", ["navbarAction"]),
    ...mapState("editor", [
      "profile",
      "isShowDownloadResume",
      "cvDetail",
      "currentInfo",
      "profile",
      "extras",
      "readyScore",
      "openResumeError",
    ]),
    ...mapState("cvs", [
      "cvs",
      "cv",
      "cvPages",
      "downloadCv",
      "editCheckData",
      "editorCvToken",
    ]),
    ...mapState("global", ["nonChrome"]),
    ...mapState("experience", ["backUpExperienceList"]),
    isMentor() {
      return window.location.href.includes("mentor");
    },
    isMember() {
      return this.personInfo.is_membership
    },
    accountToken () {
      let _t = Cookies.get('_t')
      if (_t) {
        let tokenPayload = _t && JSON.parse(window.atob(_t.split('.')[1]))
        return tokenPayload.User
      } else {
        return {}
      }
    }
  },
  watch: {
    isLogin: {
      handler(val) {
        if (val) {
          this.navList[0] = { label: "我的简历", url: "/cvs" };
          this.navList[2] = { label: "求职邮箱", url: "/emails/my" };
        } else {
          this.navList[0] = { label: "简历模板", url: "/jianlimoban/" };
          this.navList[2] = { label: "求职信", url: "/emails/my" };
        }
        this.$forceUpdate();
      },
      immediate: true,
    },
    dialogShow: {
      handler(newVal) {
        if (!newVal) {
          this.downloadState = newVal;
        }
      },
    },
    readyScore: {
      handler(newVal) {
        const cvShareTooltip = localStorage.getItem("cvShareTooltip");
        if (newVal >= 80 && !cvShareTooltip) {
          this.cvShareTooltip = true;
          localStorage.setItem("cvShareTooltip", 1);
        }
      },
    }
  },
  created() {
    // this.$store.dispatch('me/personMenu');
    // this.getIntention();
    // this.getMiniprogramImg()
    // setTimeout(this.getMiniprogramImg , 1000)
    // 获取加密token
    this.getCvEncodedToken();
    this.$eventBus.$on("download", (res) => {
      // this.trigger(res);
      this.triggerPayload = res;
      this.fetchCheckUseVipResult(res)
    });
    this.getBanner();
  },
  methods: {
    ...mapMutations("global", ["setNonChrome"]),
    ...mapMutations("editor", [
      "setCvDetail",
      "setActiveTemplateStyle",
      "setJobTabScrollActive",
      "setIsShowDownloadResume",
      "setCheckCloseEditModule",
      "setOpenSidebarModule",
      "emitShowDownBox",
      "setQuitResumeEditor",
      "updateLibraryState",
    ]),
    ...mapMutations("me", { setPersonInfo: "GET_INFO" }),
    ...mapMutations("experience", ["updateExperienceList"]),
    async fetchCheckUseVipResult(payload) {
      try {
        const params = {
          watermark: "no",
          showProfile: true,
          pageNum: this.pageNum,
          origin: "pc",
        };
        const { code, data } = await api.account.checkUseVip(this.cvDetail.basic_info.token, params);
        if (code === 1000 && !data?.use_vip && !this.isMember) {
          this.payAlertState = true;
        } else {
          this.trigger(payload)
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 点击按钮的时候回复经历库操作数据
    updateLibrary() {
      //把备份数据同步到当前经历库数据中
      this.updateExperienceList(
        JSON.parse(JSON.stringify(this.backUpExperienceList))
      );
    },
    // 防抖函数
    debounce(fn, timeInterval) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      let arg = [...arguments].filter((item, index) => {
        return index > 1;
      });
      this.timer = setTimeout(() => {
        fn.apply(this, arg);
      }, timeInterval);
    },
    modifyTextColor() {
      const el = document.querySelector('#udesk_btn a');
      const color = this.personInfo.theme === 'light' ? '#404040' : '#fff';
      if (el) {
        el.style.color = color;
      }
    },
    // 更换简历主题
    changeEditorTheme() {
      this.debounce(async () => {
        let info = JSON.parse(JSON.stringify(this.personInfo));
        if (info.theme === "light") {
          info.theme = "dark";
        } else {
          info.theme = "light";
        }
        let { c_t } = get_tUser();
        let res = await api.cvsEditor.changeEditorTheme(c_t, {
          theme: info.theme,
        });
        if (res.code === 1000) {
          this.setPersonInfo(info);
          this.modifyTextColor()
        } else {
          this.$message.error("请重试");
        }
      }, 200);
    },
    downloadClick() {
      this.updateLibrary();
      this.setJobTabScrollActive(false);
      if (this.currentInfo.operation) {
        //设置是否需要取消当前编辑状态，并返回
        this.setCheckCloseEditModule(true);
        this.emitShowDownBox(true);
      } else {
        // 预览进入到下载状态，存储目前的简历样式
        if (!this.isShowDownloadResume) {
          let obj = {
            show_attr_name: this.profile.show_attr_name,
            head_format: this.cvDetail.format_info.head_format,
            top_format: this.cvDetail.format_info.top_format,
            title_format: this.cvDetail.format_info.title_format,
            title_color: this.cvDetail.format_info.title_color,
            imgSrc: "default",
          };
          // 模版类型
          this.setFormatInfo({ template_type: "default" });
          this.setActiveTemplateStyle({ ...obj });
        } else {
          this.$message.error("请选择下载的文件类型");
        }

        this.updateLibraryState(false);
        this.setIsShowDownloadResume(true);
      }
      // this.downloadtype = parseInt(Math.random() * 5 + 1 )
      // this.downloadShow = true
      // this.downloadtype =  this.downloadtype % 5 + 1
      // this.downloadtype =  3
      // this.downloadtype =  5
    },
    //更改format_info
    setFormatInfo(options) {
      //当前模块要有 key，value
      let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
      //同步数据
      Object.keys(options).forEach((key) => {
        cvDetail.format_info[key] = options[key];
      });
      //同步到vuex中
      this.setCvDetail(cvDetail);
    },
    toRoot() {},
    toCv(nav) {
      routerTo(nav.url);
    },
    toEmail() {},
    toJob() {},
    toService() {},
    toIndex() {
      routerTo("/");
    },
    toLogin() {
      routerTo("/auth-signin/?type=login");
    },
    toReg() {
      routerTo("/auth-signin/?type=login");
    },
    changeUsePhone(type) {
      this.useByPhone = type;
    },
    show(state) {
      this[state] = true;
    },
    hide(state) {
      this[state] = false;
    },
    //  downloadBefore事件处理
    trigger(params) {
      this.downloadShow = false;
      if (params.type !== "merge") {
        this.download(params);
      } else {
        this.combineCv();
      }
    },
    async changeShareWxState() {
      if (!this.shareWxState && !this.getMiniprogramImgState) {
        let { c_t } = get_tUser();
        let {
          basic_info: { lang, token },
        } = this.cvDetail;
        let translateResp = await api.cvsEditor.verifyCanTransCv(c_t, {
          lang: lang === "cn" ? "en" : "cn",
        });
        console.log(translateResp, "translateResp==>>translateResp");

        if (translateResp.code === 600213 || translateResp.code === 3001) {
          this.$message.error(translateResp.message);
          setTimeout(() => {
            this.$store.dispatch("app/setAlertData", {
              show: true,
              type: "upVip",
              browseType: "editTranslate",
            });
          }, 300);
        } else if (translateResp.code === 1000) {
          this.getMiniprogramImgState = true;
          this.shareWxState = !this.shareWxState;
          // 获取小程序分享码
          this.getMiniprogramImg();
        }
      } else if (this.shareWxState && this.getMiniprogramImgState) {
        this.shareWxState = false;
        this.getMiniprogramImgState = false;
      }
    },
    // 获取加密token
    getCvEncodedToken() {
      let cvToken = this.$route.params.token;
      api.shareCvs
        .getCvEncodedToken(cvToken, {
          token: cvToken,
          from_admin: false,
        })
        .then(async (tokenRes) => {
          if (tokenRes.code === 1000) {
            let { encoded_token } = tokenRes.data;
            // 保存加密token
            this.cvEncodedToken = encoded_token;
            this.shareUrl = `${process.env.HOST_ROOT}/cvs/${encoded_token}/share`;
          }
        });
    },
    //获取小程序分享码
    async getMiniprogramImg() {
      let cvToken = this.$route.params.token;
      // 获取当前简历的隐私设置
      this.getCvSettings();

      let res = await api.cvsEditor.cvQr({}, cvToken);
      if (res.code === 1000) {
        this.shareimg = "data:image/png;base64," + res.data.image;
      } else {
        console.log("小程序二维码加载出错");
      }
    },
    // 复制按钮
    copy() {
      this.$copyText(this.shareUrl).then(
        (e) => {
          this.$message.success("简历链接已复制");
          // setTimeout(() => {
          //   window.open(this.shareUrl)
          // }, 500);
        },
        (error) => {
          this.$message.error("复制失败");
        }
      );
    },
    // 获取求职意向
    async getIntention() {
      let userIntentionsQuery = await dealSignatrue();
      let userIntentions = await api.recruit.jobIntention(userIntentionsQuery);
      if (userIntentions.code && userIntentions.code === 1000) {
        await this.$store.dispatch("jobs/getIntention", userIntentions.data);
      }
      // 行业，筛选数据登
      await this.$store.dispatch("jobs/setIntention", conditions);
      this.intentionShow = true;
    },
    // 简历私密度
    async privacy() {
      const alertData = {
        show: true,
        type: "privacy",
        showCancelButton: true, //取消按钮
        showConfirmButton: true, // 确定按钮
        confirmButtonText: "保存",
        cancelButtonText: "取消",
        visibility: this.cv.base.visibility,
        // cancelButtonClass: 'cvs-edit-cancelButtonClass',
        // confirmButtonClass: 'cvs-edit-confirmButtonClass',
        cancel: (close) => {
          close();
        },
        confirm: async (close, visibility) => {
          let params = {
            cv_token: this.editorCvToken,
            visibility,
          };
          params = await dealSignatrue(params);
          let res = await api.cvs.updateVisibility(params);
          if (res.status === 0 && res.type === "err_msg") {
            this.$message.error(res.message);
          } else if (
            res.status === 0 &&
            res.type === "confirm_change_visibility_private_modal"
          ) {
            let applies = await this.getHrList();
            close();
            clearTimeout(run);
            let str = "";
            str += `
                  <p style="color: #9C9C9C;">简历状态为 HR 可见，删除以下 HR 将无法查看你的简历</p>
                  <div style="padding: 12px 16px;background: #F9F9F9;margin-top: 12px;">
                `;
            for (
              let i = 0;
              i < (applies.length > 2 ? 2 : applies.length);
              i++
            ) {
              str += `
                    <div class="text-overflow; max-width: 100%;">${applies[i].company} ${applies[i].positoin} | ${applies[i].name}</div>
                  `;
            }
            if (applies.length > 2) {
              str +=
                '<a href="/inbox" style="color: #9C9C9C;">查看全部 HR ＞</a>';
            }
            str += `
                  </div>
                  <p style="color: #FF453E;font-size: 15px;margin-top: 18px;">请确认是否删除该份简历</p>hui
                `;
            run = setTimeout(() => {
              this.$store.dispatch("app/setAlertData", {
                show: true,
                type: "message",
                messageTitle: "确认提示",
                showCancelButton: true, //取消按钮
                showConfirmButton: true, // 确定按钮
                confirmButtonText: "取消",
                cancelButtonText: "确定",
                cancelButtonClass: "cvs-edit-cancelButtonClass",
                confirmButtonClass: "cvs-edit-confirmButtonClass",
                messageContent: str,
                confirm: (close) => {
                  close();
                },
                cancel: async (close) => {
                  let params = {
                    cv_token: this.editorCvToken,
                    visibility,
                    confirm_change_visibility_private_modal: true,
                  };
                  params = await dealSignatrue(params);
                  let res = await api.cvs.updateVisibility(params);
                  if (res.status === 1) {
                    this.$message.success("修改成功");
                    this.$store.dispatch("cvs/getCv", this.editorCvToken);
                    close();
                  } else {
                    this.$message.error(res.message);
                  }
                },
              });
            }, 100);
          } else if (
            res.status === 0 &&
            res.type === "confirm_change_visibility_modal"
          ) {
            close();
            clearTimeout(run);
            run = setTimeout(() => {
              const alertData = {
                show: true,
                type: "message",
                messageTitle: "更换简历",
                showCancelButton: true, //取消按钮
                showConfirmButton: true, // 确定按钮
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                // cancelButtonClass: 'cvs-edit-cancelButtonClass',
                // confirmButtonClass: 'cvs-edit-confirmButtonClass',
                messageContent: `
                    <p>您已有一份简历为 HR 可见，更换后该简历将转为私密简历</p>
                    <p style="color: #FF453E">确定更换当前简历权限为 HR 可见吗？</p>
                  `,
                cancel: (close) => {
                  close();
                },
                confirm: async (close) => {
                  let params = {
                    cv_token: this.editorCvToken,
                    visibility,
                    confirm_change_visibility_modal: true,
                  };
                  params = await dealSignatrue(params);
                  let res = await api.cvs.updateVisibility(params);
                  if (res.status === 1) {
                    this.$message.success("修改成功");
                    this.$store.dispatch("cvs/getCv", this.editorCvToken);
                    close();
                  } else {
                    this.$message.error(res.message);
                  }
                },
              };
              this.$store.dispatch("app/setAlertData", alertData);
            }, 120);
          } else if (res.status === 0 && res.type === "create_job_intention") {
            close();
            this.getIntention();
          } else if (res.status === 1) {
            this.$message.success("修改成功");
          } else {
            this.$message.error("网络开小差了");
            return false;
          }
          this.$store.dispatch("cvs/getCv", this.editorCvToken);
          close();
        },
      };
      this.$store.dispatch("app/setAlertData", alertData);
    },
    async getHrList() {
      let params = {
        cv_token: this.editorCvToken,
      };
      params = await dealSignatrue(params);
      let res = await api.cvs.getCvApplies(params);
      return res.applies;
    },
    // 翻译简历
    async translate() {
      this.updateLibrary();
      // this.$message.error('翻译服务暂不可用，升级中敬请期待')
      // return
      if (this.isTranslate) return false;
      let {
        basic_info: { lang, token },
      } = this.cvDetail;
      let { c_t } = get_tUser();
      this.isTranslate = true;
      const fn = async () => {
        let loading = this.$message({
          iconClass: "el-icon-loading",
          duration: 0,
          message: "正在翻译",
        });
        let params = {
          cv_token: this.cvDetail.basic_info.token,
        };
        let res = await api.cvsEditor.translateCv(params);
        loading.close();
        this.isTranslate = false;
        if (res.code === 1000) {
          this.$message.success("翻译成功");
          routerTo(`/cvs/${res.data.basic_info.token}/editor`, "_blank");
        } else {
          this.$message.error(res.message);
        }
      };
      let translateResp = await api.cvsEditor.verifyCanTransCv(c_t, {
        lang: lang === "cn" ? "en" : "cn",
      });
      if (translateResp.code === 1000) {
        if (
          (await this.verifyCanCreate(
            lang === "cn" ? "en" : "cn",
            token,
            fn,
            "editTranslate"
          )) === "createError"
        ) {
          this.isTranslate = false;
          return;
        }
      } else if (translateResp.code !== 2000) {
        this.isTranslate = false;
        this.$message.error(translateResp.message);
        console.log(translateResp, "translateResp.code==>>>");

        if (translateResp.code === 600213) {
          setTimeout(() => {
            this.$store.dispatch("app/setAlertData", {
              show: true,
              type: "upVip",
              browseType: "editTranslate",
            });
          }, 300);
        }
        // if (translateResp.code === 3001) {
        //   setTimeout(() => {
        //     this.$store.dispatch('app/setAlertData', {show: true, type: 'upVip', browseType: 'editTranslate'});
        //   }, 300);
        // }
      }
    },
    // 复制简历
    async dumpCv() {
      this.updateLibrary();
      if (this.isDump) return false;
      this.isDump = true;
      let {
        basic_info: { token, lang },
      } = this.cvDetail;
      const fn = async () => {
        let loading = this.$message({
          iconClass: "el-icon-loading",
          duration: 0,
          message: "正在复制",
        });
        let params = {
          cv_token: this.cvDetail.basic_info.token,
        };
        let res = await api.cvsEditor.duplicateCvs(params);
        this.isDump = false;
        loading.close();
        if (res.code === 1000) {
          this.$message.success("复制成功 正在跳转。。。");
          routerTo(`/cvs/${res.data.basic_info.token}/editor`, "_blank");
        }
      };
      if (
        (await this.verifyCanCreate(lang, token, fn, "editCopy")) ===
        "createError"
      ) {
        this.isDump = false;
        return;
      }
    },
    // 删除简历
    deleteCv() {
      this.updateLibrary();
      if (this.isDelete) return false;

      const alertData = {
        show: true,
        type: "message",
        messageTitle: "删除提示",
        showCancelButton: true, //取消按钮
        showConfirmButton: true, // 确定按钮
        confirmButtonText: "取消",
        cancelButtonText: "删除",
        cancelButtonClass: "cvs-edit-cancelButtonClass",
        confirmButtonClass: "cvs-edit-confirmButtonClass",
        messageContent: `
            <p>删除提示</p>
            <p style="color: #FF453E">确定要删除当前简历吗?</p>
          `,
        confirm: (close) => {
          close();
        },
        cancel: async (close) => {
          this.isDelete = true;
          let loading = this.$message({
            iconClass: "el-icon-loading",
            duration: 0,
            message: "正在删除",
          });
          let res = await api.cvsEditor.deleteCv(
            this.cvDetail.basic_info.token
          );
          this.isDelete = false;
          loading.close();
          if (res.code === 1000) {
            this.$message.success("删除成功");
            close();
            setTimeout(() => {
              routerTo("/cvs");
            }, 150);
          } else {
            close();
            this.$message.error(res.message);
          }
        },
      };
      this.$store.dispatch("app/setAlertData", alertData);
    },
    //显示修改简历名称弹窗
    editCvName(token, name) {
      //检测是否有profile数据
      let { kind } = this.cvDetail.basic_info;
      if (kind === "template" || kind === "sample") {
        this.$message.error("请先完善简历信息");
        return false;
      }
      this.renameModalShow = !!token;
      this.renameCvToken = token;
      this.renameCvName = name;
    },
    // 返回我的简历
    toCvs() {
      // 没有在编辑中
      if (!this.currentInfo.type) {
        this.updateLibrary();
        routerTo("/cvs");
      } else {
        // 编辑状态中
        this.setQuitResumeEditor(true);
      }
    },
    // 投递
    sendCv(token) {
      this.sendCvModalShow = !!token;
    },
    // 打印
    async printCv() {
      this.updateLibrary();
      let params = {
        hideProfile: this.isMentor,
      };
      let res = await api.cvsEditor.getCvHtml(this.cvEncodedToken, params);
      let html = "";
      if (res.code === 1000) {
        html = res.data[0];
      }

      var mywindow = window.open("");
      document.getElementById("print-cover").style.display = "block";
      mywindow.document.write(
        "<html style='background: #f5f5f7;'><head><title></title>"
      );
      mywindow.document.write(
        "</head><body style=' width: 210mm; margin: auto; background: #fff; min-height: 293mm; '>"
      );
      mywindow.document.write(html);
      mywindow.document.write("</body></html>");
      mywindow.document.close();
      mywindow.focus();
      setTimeout(function () {
        mywindow.print();
        mywindow.close();
        document.getElementById("print-cover").style.display = "none";
      }, 200);
      return true;
    },
    // 分享
    async share() {
      let params = {};
      let alertData = {
        show: true,
        type: "shareCv",
        shareUrl: `${process.env.HOST_ROOT}/cvs/${this.$route.params.token}/share`,
      };
      this.$store.dispatch("app/setAlertData", alertData);
    },
    // 下载 如果type是combine，cvTokens必填；其他情况可以不填cvTokens
    async download({ type, cvTokens }) {
      if (this.isDownloadCv) {
        return false;
      }
      // this.dialogShow = true
      this.isDownloadCv = true;
      let downloadLoading = this.$message({
        message: "正在下载",
        iconClass: "el-icon-loading",
        duration: 0,
      });
      let res;
      let params = {
        watermark: "no",
        showProfile: true,
        pageNum: this.pageNum,
        origin: "pc",
      };
      if (type === "pdf") {
        res = await api.cvsEditor.downloadCv(
          this.cvDetail.basic_info.token,
          params
        );
      } else if (type === "img") {
        res = await api.cvsEditor.downloadCvImg(
          this.cvDetail.basic_info.token,
          params
        );
      } else if (type === "combine") {
        res = await api.cvsEditor.downloadCombinedCv(
          this.cvDetail.basic_info.token,
          { ...params, token_list: cvTokens }
        );
      } else {
        this.$message.error("请选择下载简历类型");
        this.isDownloadCv = false;
        downloadLoading.close();
        return false;
      }
      // 会员阻断
      if (res.code === 80160) {
        const alertData = {
          show: true,
          type: "upVip",
          browseType: "downloadCv",
        };
        this.setAlertData(alertData);
        this.isDownloadCv = false;
        downloadLoading.close();
        return false;
      }
      if (res.code === 80120) {
        this.$message.error("请先完善简历信息");
        this.isDownloadCv = false;
        downloadLoading.close();
        return false;
      }
      if (!res.data.url) {
        this.$message.error("下载失败");
        this.isDownloadCv = false;
        downloadLoading.close();
        return false;
      }
      if (this.cvDetail.basic_info.lang === "cn") {
        api.planning.getExperience(this.$route.params.token).then((res) => {
          if (res.code === 1000) {
            // && (res.data.edus.length > 0 || res.data.works.length > 0)
            // let cvDownloaded = localStorage.getItem('cvDownloaded')
            // if (!cvDownloaded) {
            //   window.open(`/planning/${this.$route.params.token}/index`, '_blank')
            //   localStorage.setItem('cvDownloaded', true)
            // }
            // if(this.personInfo.is_student==true){
            //   window.open(`https://www.wondercv.com/mini_activity/GP0k1vrp`, '_blank');
            // }else{
            //   window.open(`https://www.wondercv.com/mini_activity/wEZQ4721`, '_blank');
            // }
            // let { link = '' } = this.banner || {};
            // const parsedUrl = new URL(link);

            // const downloadQuery = 'pageSource=download';

            // if (parsedUrl.search === '') {
            //   link = `${link}?${downloadQuery}`
            // } else if (link.endsWith('&')) {
            //   link = `${link}${downloadQuery}`
            // } else {
            //   link = `${link}&${downloadQuery}`
            // }
            // window.open(link, "_blank");
            // console.log(this.banner,111111);
          }
        });
      }
      this.displayAdBanner();
      axios({
        url: res.data.url,
        method: "get",
        responseType: "blob",
      })
        .then(async (r) => {
          if (type === "pdf") {
            downloadjs(
              r.data,
              this.cvDetail.basic_info.cv_name + ".pdf",
              "pdf"
            );
          } else if (type === "img") {
            downloadjs(
              r.data,
              this.cvDetail.basic_info.cv_name + ".png",
              "image/png"
            );
          } else if (type === "combine") {
            downloadjs(
              r.data,
              this.cvDetail.basic_info.cv_name + "(中英).pdf",
              "pdf"
            );
          }
          this.isDownloadCv = false;
          downloadLoading.close();
          this.$message.success("下载成功");
          this.downloadState = true;
        })
        .catch((err) => {
          this.isDownloadCv = false;
          downloadLoading.close();
          this.$message.error("下载失败");
        });
    },
    async displayAdBanner() {
      // try {
      //   let res = await api.jobs.getBanner({ position: '138' })
      //   if (res.code === 1000) {
      //     const afterMinus = await displayBannerSaveHistory(res.data?.length, 'downloadBanner');
      //     if (afterMinus === 0 || afterMinus) {
      //       this.alertData = {
      //         show: true,
      //         type: 'cvsguanggao',
      //         image: res.data[afterMinus],
      //       }
      //     }
      //   }
      // } catch (error) {
      //   console.log(error);
      // }
      let resumeText = ''
      try {
        let cv_account_token = this.accountToken.c_t
        let resumePreviewDom = document.querySelector('.resume-preview-wrapper')
        let oldResumePreviewDom = document.querySelector('#cv-container')
        if(resumePreviewDom){
          resumeText = resumePreviewDom.innerText;
          updateAccountResumeText(cv_account_token, resumeText);
        }else if(oldResumePreviewDom){
          resumeText = oldResumePreviewDom.innerText;
          updateAccountResumeText(cv_account_token, resumeText);
        }
      } catch (error) {
        console.error(error);
      }
      try {
        let res = await api.jobs.getV4Banner(getBannerParams(138));
        if (res.code === 1000) {
          let bannerList = res.data || [];
          // 过滤关键词
          bannerList = bannerList.filter(item => {
            if(item.keyword && item.keyword.length){
              return item.keyword.some(sitem => {
                return resumeText.toLocaleLowerCase().includes(sitem.toLocaleLowerCase());
              });
            }else{
              return true
            }
          })
          // console.log(111, bannerList)
          const afterMinus = await displayBannerSaveHistory(bannerList?.length, 'downloadBanner');
          if (afterMinus === 0 || afterMinus) {
            this.alertData = {
              show: true,
              type: 'cvsguanggao',
              image: bannerList[afterMinus],
            };
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    //获取banner
    async getBanner() {
      // 下载跳转链接banner
      // try {
      //   let res = await api.jobs.getBanner({ position: "89" });
      //   this.banner = res.data[0];
      //   console.log(res.data, 999);
      // } catch (e) {
      //   console.log(e);
      // }
    },
    // 合并简历弹窗
    combineCv() {
      this.updateLibrary();
      this.combineDialogShow = true;
    },

    // 关闭合并简历弹窗
    handleCombineClose() {
      this.combineDialogShow = false;
    },

    // 关闭下载简历弹窗
    handleClose() {
      this.dialogShow = false;
      this.downloadShow = false;
      this.alertData.show = false;
    },

    // 关闭非Chrome浏览器弹窗
    close() {
      this.setNonChrome();
    },

    // 更新公开分享 状态
    updatePublicVisibility(data, type) {
      api.shareCvs.putCvSettings(this.cvEncodedToken, data).then((res) => {
        if (res.code === 1000) {
          this.settingData = {
            ...this.settingData,
            ...data,
          };
          if (type === "public_visibility") {
            this.$message.success(
              data.public_visibility
                ? "已打开，将自动记录打开链接的人"
                : "已关闭，打开可记录并管理查看链接的人"
            );
          } else if (type === "visibility_type") {
            this.$message.success(
              data.visibility_type === 20
                ? "已对获得链接的人完整可见"
                : "已对获得链接的人保护隐私"
            );
          }
          // this.$message.success(`简历查看权限已${state?'打开':'关闭'}`);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取简历查看权限
    getCvSettings() {
      api.shareCvs.getCvSettings(this.cvEncodedToken).then((res) => {
        if (res.code === 1000) {
          this.settingData = res.data;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~/assets/css/variable";
.ponter {
  cursor: pointer;
}
// 简历主题样式
.change-theme {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #414653;
  margin-right: 10px;
  position: relative;
  //position: fixed;
  //right: 30px;
  //bottom: 148px;
  cursor: pointer;
  overflow: hidden;
  img {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    margin: auto;
    width: 20px;
  }
  .dark-theme {
    width: 18px;
  }
}
.icon-enter-active,
.icon-leave-active {
  transition: all 0.3s;
}
.icon-enter,
.icon-leave-to {
  transform: translateY(200%);
}
.close {
  color: #ff6644;
  position: absolute;
  top: 0px;
  right: 32px;
  font-size: 24px;
  cursor: pointer;
}
.nonChrome {
  width: 100%;
  height: 40px;
  background-color: #fff6f4;
  color: #ff6644;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  position: relative;
}
#print-cover {
  display: none;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  min-height: 1200px;
  position: absolute;
  cursor: none;
  font-size: 24px;
  line-height: 400px;
  text-align: center;
}
.pc-nav {
  position: fixed;
  margin: 0;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 10;
  background-color: #202329;
  box-sizing: border-box;

  .nav-container {
    height: 56px;
    line-height: 56px;
    min-width: 1196px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    // 新版新加cvs
    .cv {
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 14px;
      .cv-me {
        cursor: pointer;
        display: flex;
        align-items: center;
        margin-right: 36px;
        &:hover {
          .iconfont,
          span {
            font-weight: bold;
          }
        }
        .iconfont {
          font-size: 18px;
          margin-right: 8px;
        }
      }
      .cv-name {
        cursor: pointer;
        font-size: 14px;
        color: #fff;
        display: flex;
        align-items: center;
        &:hover {
          .cv-name-n {
            font-weight: bold;
          }
          .iconbianji {
            font-weight: bold;
          }
        }
        .cv-name-n {
          max-width: 300px;
          height: 18px;
          line-height: 16px;
          margin-top: 3px;
          font-weight: 400;
        }
        .iconbianji {
          font-size: 12px;
          margin-left: 6px;
        }
      }
    }

    .logo {
      display: inline-block;
      vertical-align: middle;
      height: 34.6px;
      margin-left: 1%;
      position: relative;
      z-index: 3;
      cursor: pointer;
    }

    .right-part {
      flex: none;
      // min-width: 230px;
      height: 100%;
      z-index: 3;
      & > div {
        display: flex;
        align-items: center;
        height: 100%;
        justify-content: flex-end;
      }
      .line {
        width: 1px;
        height: 16px;
        background: #36393e;
        margin: 0 16px;
      }
      button {
        width: 80px;
        height: 32px;
        border: 1px solid $color-theme;
        color: $color-theme;
        background: #fff;
        cursor: pointer;
        margin-left: 16px;
        border-radius: 2px;
        font-size: 14px;
        &.action,
        &:hover {
          background: $color-theme;
          color: #fff;
        }
        &.margin-left {
          margin-left: 13px;
        }
      }
      .down-app {
        color: #ffffff;
        & span {
          font-size: 14px;
          font-weight: 400;
          margin-left: 6px;
          font-family: PingFangSC-Regular, PingFang SC;
          line-height: 20px;
        }
      }
      .cv-btn {
        width: 76px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border: 1px solid #797b7e;
        border-radius: 15px;
        font-size: 14px;
        color: #fff;
        position: relative;
        z-index: 1;
        .more-icon {
          height: 46px;
          cursor: pointer;
        }
        &:hover {
          border: 1px solid #fff;
        }
        &.fontb {
          font-size: 14px;
          font-weight: 700;
        }
        &:hover .cv-option {
          display: block;
        }
        &.share {
          background: #ff6644;
          border: 1px solid #ff6644;
        }
        &.share:hover {
          border: 1px solid #ff856a;
          background: #ff856a;
          & .cv-share {
            display: block;
          }
        }
        &.tran:hover {
          border-color: #fff;
        }
        .cv-option {
          display: none;
          width: 170px;
          background: #f9f9f9;
          border-radius: 4px;
          position: absolute;
          bottom: -14px;
          left: 50%;
          // margin-left: 33px;
          transform: translate(-50%, 100%);
          box-shadow: 0px 2px 12px 0px rgba(128, 128, 128, 0.12);
          overflow: hidden;
          z-index: 30;
          .cv-list {
            width: 100%;
            cursor: pointer;
            height: 53px;
            background: #fff;
            color: #404040;
            font-size: 14px;
            position: relative;
            line-height: 14px;
            line-height: 53px;
            text-align: left;
            &:hover {
              background: #f9f9f9;
            }
            .icoImg {
              position: absolute;
              top: 50%;
              transform: translate(0, -50%);
              right: 10px;
              width: 22px;
            }
            .iconfont {
              margin-left: 28px;
              margin-right: 22px;
            }
          }
          .margin-top-6 {
            margin-top: 6px;
          }
          .after:after {
            content: "";
            display: block;
            width: 164px;
            height: 1px;
            background: #ececec;
            position: absolute;
            bottom: 0;
            left: 18px;
          }
        }

        &:hover .hover {
          display: block;
        }
        .hover {
          display: none;
          width: 70px;
          height: 24px;
          color: #404040;
          font-size: 12px;
          line-height: 24px;
          text-align: center;
          position: absolute;
          left: 50%;
          margin-left: -35px;
          bottom: -12px;
          transform: translateY(100%);
          box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.08);
          border-radius: 2px;
          background: #fff;
          &::after {
            content: "";
            display: block;
            width: 4px;
            height: 4px;
            background: #fff;
            position: absolute;
            transform-origin: 50% 50%;
            transform: rotate(45deg);
            top: -2px;
            left: 50%;
            margin-left: -2px;
          }
        }
        .cv-share {
          display: none;
          width: 477px;
          height: 261px;
          background: #ffffff;
          box-shadow: 0px 2px 12px 0px rgba(128, 128, 128, 0.16);
          border-radius: 4px;
          position: absolute;
          right: -50px;
          top: 44px;
          .auth-switch {
            margin: 10px 0 10px;
            .auth-switch-tips {
              font-size: 12px;
              color: #606060;
              margin-left: 8px;
            }
          }
          .send-to-wechat,
          .send-to-email {
            text-align: left;
            & .nav {
              height: 18px;
              font-size: 18px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #404040;
              line-height: 18px;
            }
            & .title {
              height: 14px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #606060;
              line-height: 14px;
              margin-top: 11px;
              margin-bottom: 15px;
            }
          }
          .send-to-wechat {
            cursor: default;
            // overflow: hidden;
            .left {
              flex: 1;
            }
            .share-cv-qrcode {
              width: 102px;
              height: 102px;
              margin-left: 22px;
              ::v-deep img {
                display: block;
                width: 100%;
                height: 100%;
              }
            }
          }
          .copy-link {
            position: relative;
            height: 34px;
            border-radius: 4px;
            border: 1px solid #ececec;
            line-height: 34px;
            cursor: pointer;
            font-size: 14px;
            .auth-select-text {
              flex: 1;
              color: #404040;
              text-align: center;
              .iconfont {
                font-size: 12px;
              }
              &:hover {
                .auth-select {
                  display: block;
                }
              }
              .auth-select {
                left: 0;
                right: 0;
                top: 40px;
                box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.05);
                border-radius: 4px;
                border: 1px solid #ececec;
                text-align: left;
                display: none;
                &:before {
                  width: 100%;
                  height: 4px;
                  display: block;
                  position: absolute;
                  content: "";
                  top: -6px;
                }
                .select-item {
                  line-height: 40px;
                  color: #404040;
                  padding-left: 12px;
                  cursor: pointer;
                  &-select,
                  &:hover {
                    background: #f4f4f4;
                  }
                }
              }
            }
            &-btn {
              width: 94px;
              text-align: center;
              border-left: 1px solid #ececec;
              color: #ff6644;
              line-height: 34px;
              &:hover {
                font-weight: bold;
              }
            }
          }
          .send-to-email {
            cursor: pointer;
            margin-top: 42px;
            & :hover .nav {
              color: #ff6644 !important;
            }
          }
        }
        .cv-share-new {
          width: 160px;
          height: 105px;
          padding: 0 18px;
          box-sizing: border-box;
          .cv-share-item {
            display: flex;
            align-items: center;
            width: 124px;
            padding-left: 8px;
            text-align: left;
            color: #404040;
            height: 52px;
            cursor: pointer;
            i {
              margin-right: 20px;
            }
            &:first-child {
              border-bottom: 1px solid #ececec;
            }
          }
        }
        .cv-share-tooltip {
          display: flex;
          align-items: center;
          position: absolute;
          right: -50px;
          top: 46px;
          width: max-content;
          background-color: rgba($color: #000000, $alpha: 0.9);
          border-radius: 6px;
          box-shadow: 0 2px 12px 0 rgba($color: #808080, $alpha: 0.12);
          padding: 16px 20px;
          height: 14px;
          line-height: 14px;
          i {
            margin-left: 16px;
            font-size: 18px;
            font-weight: 500;
            cursor: pointer;
          }
          &::before {
            content: "";
            position: absolute;
            bottom: 100%;
            left: 68%;
            width: 0;
            height: 0;
            border: 9px solid transparent;
            border-bottom: 8px solid rgba($color: #000, $alpha: 0.9);
          }
        }
      }
      .cv-icon {
        color: #797b7e;
        position: relative;
        .iconfont {
          font-size: 20px;
        }
        &:hover {
          color: #fff;
          .hover {
            display: block;
          }
        }
        .hover {
          display: none;
          width: 70px;
          height: 24px;
          font-size: 12px;
          color: #404040;
          line-height: 24px;
          text-align: center;
          position: absolute;
          left: 50%;
          margin-left: -35px;
          bottom: -12px;
          transform: translateY(100%);
          box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.08);
          border-radius: 2px;
          background: #fff;
          &::after {
            content: "";
            display: block;
            width: 4px;
            height: 4px;
            background: #fff;
            position: absolute;
            transform-origin: 50% 50%;
            transform: rotate(45deg);
            top: -2px;
            left: 50%;
            margin-left: -2px;
          }
        }
      }
      .margin-right-12 {
        margin-right: 12px;
      }
      .margin-right-24 {
        margin-right: 24px;
      }
    }
  }
}
.share-wechat-dialog-container {
  .share-wechat-cover {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 7;
  }
  .share-wechat-content {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    padding: 32px 20px;
    border-radius: 8px;
    background-color: #fff;
    top: 24%;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 340px;
    box-sizing: border-box;
    z-index: 8;
    .share-wechat-title {
      color: #303030;
      margin-bottom: 32px;
      font-size: 24px;
      font-weight: 500;
    }
    .send-to-wechat {
      cursor: default;
      // overflow: hidden;
      & .nav {
        height: 18px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #404040;
        line-height: 18px;
      }
      & .title {
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #606060;
        line-height: 14px;
        margin-top: 11px;
        margin-bottom: 15px;
      }
      .left {
        flex: 1;
      }
    }
    .copy-link {
      position: relative;
      height: 34px;
      border-radius: 4px;
      border: 1px solid #ececec;
      line-height: 34px;
      cursor: pointer;
      font-size: 14px;
      margin-bottom: 24px;
      width: 100%;
      .auth-select-text {
        flex: 1;
        color: #404040;
        padding-left: 16px;
        padding-right: 20px;
        display: flex;
        .iconfont {
          font-size: 12px;
          margin-left: 2px;
        }
        &:hover {
          .auth-select {
            display: block;
          }
        }
        .auth-select {
          left: 0;
          right: 0;
          top: 40px;
          box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.05);
          border-radius: 4px;
          border: 1px solid #ececec;
          text-align: left;
          display: none;
          &:before {
            width: 100%;
            height: 4px;
            display: block;
            position: absolute;
            content: "";
            top: -6px;
          }
          .select-item {
            line-height: 40px;
            color: #404040;
            padding-left: 12px;
            cursor: pointer;
            &-select,
            &:hover {
              background: #f4f4f4;
            }
          }
        }
      }
      .auth-select-disabled {
        color: #404040;
        background-color: #f9f9f9;
      }
      &-btn {
        width: 94px;
        text-align: center;
        border-left: 1px solid #ececec;
        color: #ff6644;
        line-height: 34px;
        &:hover {
          font-weight: bold;
        }
      }
    }
    .share-cv-qrcode {
      width: 158px;
      height: 158px;
      ::v-deep img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .cv-share-desc {
      color: #9c9c9c;
      margin-top: 28px;
    }
  }
}
</style>
